import React, {useState, useEffect} from 'react'
import Logo from '../assets/logo.jpeg';
import { Link, NavLink } from 'react-router-dom'

const Header = () => {

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false); 

  const handleLinkClick = () => {
    setIsCollapsed(true); // Collapse the navbar after link click
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) { // Change 50 to the scroll position you want
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Attach scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <>
<nav className={`navbar navbar-expand-lg sticky-top ${isScrolled ? 'bg-white shadow-sm' : ''}`}>
<div className="container">
    <Link className="navbar-brand py-0" to='/'><img src={Logo} className='img-fluid' alt='Site Logo' style={{height: '3.5em'}} /></Link>
    <button className="navbar-toggler" onClick={() => setIsCollapsed(!isCollapsed)} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <i class="fa-solid fa-bars"></i>
    </button>
    <div className={`collapse navbar-collapse justify-content-center ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item my-3">
          <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/'>Home</NavLink>
        </li>
        <li className="nav-item my-3">
          <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/about'>About</NavLink>
        </li>
        <li className="nav-item my-3">
          <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/projects'>Projects</NavLink>
        </li>
        <li className="nav-item my-3">
          <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/blogs'>Blogs</NavLink>
        </li>
        <li className="nav-item my-3">
          <NavLink className="nav-text" activeClassName="active" onClick={handleLinkClick} to='/contact'>Contact</NavLink>
        </li>
        <li className="nav-item my-3">
          <NavLink className="banner-btn py-2 px-4" onClick={handleLinkClick} to='/account'>Login</NavLink>
        </li>
      </ul>
    </div>
  </div>
</nav>
    </>
  )
}

export default Header
